<template>
  <div class="login">
    <van-form style="margin-top: 100px" @submit="onSubmit">
      <div style="width: 60px; height: 60px; margin: 0px auto">
        <!-- <img
          style="width: 60px; height: 60px; margin: 0px auto"
          src="../assets/logo.png"
        /> -->
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
      >
        <span style="color: #52c1b2; font-size: 20px; font-weight: 580"
          >教育综合服务管理平台</span
        >
        <span
          style="margin-top: 30px; color: #999999; font-size: 20px; font-weight: 500"
        ></span>
      </div>

      <div style="margin-top: 30px"></div>
      <van-cell-group inset>
        <van-field
          v-model="username"
          label="账号"
          placeholder="请输入登录账号"
          maxlength="20"
          :rules="[{ required: true }]"
          clearable
        />
        <van-field
          v-model="password"
          type="password"
          label="密码"
          placeholder="请输入密码"
          maxlength="20"
          clearable
          :rules="[{ required: true }]"
        />
      </van-cell-group>

      <!-- 记住密码 -->
      <div class="remember-pwd-wrapper">
        <label class="remember-pwd-label">
          <input type="checkbox" v-model="rememberPwd" class="remember-pwd-checkbox" />
          <span class="remember-pwd-text">记住密码</span>
        </label>
      </div>

      <!-- <div style="margin: 20px 20px">
        <span
          class="forget"
          style="float: right; color: #999999; font-size: 12px"
          @click="toResetPwd"
          >忘记密码?</span
        >
      </div> -->

      <div style="margin: 16px 18px">
        <van-button round block type="primary" native-type="submit">登录 </van-button>
      </div>

      <!-- 账号提示文案与小程序 pages/login/login.wxml:47 保持一致 -->
      <div class="login-tip">账号密码由学校管理员分配，如忘记请联系学校进行重置</div>
    </van-form>
    <!-- 服务电话（纯展示不可点）：号码唯一来源见 src/config.js 的 SERVICE_PHONES -->
    <div class="service-hotline">
      <div class="hotline-label">服务电话</div>
      <div class="hotline-nums">
        <span v-for="p in servicePhones" :key="p">{{ p }}</span>
      </div>
    </div>
  </div>
  <van-dialog show-cancel-button :before-close="onBeforeClose" @confirm="handleConfirm">
  </van-dialog>
</template>

<script>
import { ref, onMounted } from "vue";
import { Toast } from "vant";
import { useRouter } from "vue-router";
import api from "../service/api";
import { IS_WECHAT_ENV, SERVICE_PHONES } from "../config";
import { encryption, decryption } from "../common/js/utils";
import { applyLoginResult } from "../utils/auth";

export default {
  setup() {
    const username = ref();
    const password = ref();
    const rememberPwd = ref(true);
    const servicePhones = SERVICE_PHONES;
    const router = useRouter(); //传值
    const openid = ref();
    onMounted(async () => {
      // 页面加载时静默获取 openid
      getOpenId();

      // 回填已保存的账号密码
      const savedUserNo = localStorage.getItem("userNo");
      const savedPwd = localStorage.getItem("pwd");
      if (savedUserNo && savedPwd) {
        username.value = savedUserNo;
        password.value = decryption(savedPwd);
        rememberPwd.value = true; // 有保存记录才勾选
      }
    });
    // const toResetPwd = () => {
    //   router.push({
    //     path: "/resetpwd",
    //   });
    // };

    const onSubmit = async () => {
      if (!isPone(username.value)) {
        Toast("账号格式不正确，请输入登录账号");
        return;
      }

      if (!isPwd(password.value)) {
        Toast("密码格式为6-18位数字字母或其组合");
        return;
      }

      const openId = localStorage.getItem("openId");
      if (IS_WECHAT_ENV && !openId) {
        Toast("请通过微信服务号菜单进入页面，以获取身份信息");
        return;
      }

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      api
        .login({
          user_no: username.value,
          password: password.value,
          openID: openid.value,
        })
        .then((res) => {
          if (res.data.code == 1001) {
            let result = res.data.result;

            // 根据记住密码状态决定是否保存账号密码
            if (rememberPwd.value) {
              localStorage.setItem("userNo", result.user_no);
              localStorage.setItem("pwd", encryption(password.value));
            } else {
              localStorage.removeItem("userNo");
              localStorage.removeItem("pwd");
            }
            // 本次登录的密码无条件留一份（会话级）：供"账号"页点「保存此账号」取用，
            // 这样没勾"记住密码"也能保存；关掉标签页即失效，不长期留存
            sessionStorage.setItem("curPwdEnc", encryption(password.value));

            // 落库 + 算跳转路径：与"切换账号"、"sid 失效重登"共用同一份逻辑，避免抄多份漂移
            const r = applyLoginResult(result, result.sid);
            if (!r.ok) {
              Toast(r.msg || "登录失败");
              return;
            }
            if (r.path === "/myCourese") toMyCourese();
            else if (r.path === "/dutyInspect") router.replace({ path: "/dutyInspect" });
            else toTeacherHome();
          } else {
            Toast(res.data.message);
          }
        })
        .catch((err) => {
          Toast(err.message);
        });
    };

    function toMyCourese() {
      router.replace({
        path: "/myCourese",
      });
    }

    function toTeacherHome() {
      router.replace({
        path: "/teacherHome",
      });
    }

    function isPone(phone) {
      // 账号：字母、数字或其组合，长度2-20位
      var reg = /^[A-Za-z0-9]{8,20}$/;
      if (reg.test(phone)) {
        return true;
      } else {
        return false;
      }
    }

    function isPwd(pwd) {
      var regPwd = /^[a-zA-Z0-9~!@#$%^&*?]{6,24}$/;
      if (regPwd.test(pwd)) {
        return true;
      } else {
        return false;
      }
    }

    function getOpenId() {
      //1. 检查本地缓存
      const cachedOpenId = localStorage.getItem("openId");
      if (cachedOpenId) {
        openid.value = cachedOpenId;
        return;
      }
      // 2. 检查 URL 是否有 code 参数
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");
      if (code) {
        api
          .getOpenId({
            authorizationCode: code,
          })
          .then((res) => {
            if (res.data.code == 1001) {
              let result = res.data.result;
              localStorage.setItem("openId", result.openid);
              openid.value = result.openid;
              const url = new URL(window.location.href);
              url.searchParams.delete("code");
              url.searchParams.delete("state");
              window.history.replaceState({}, "", url.toString());
            } else {
              Toast("获取身份信息失败，请刷新页面重试");
            }
          });
      } else if (IS_WECHAT_ENV) {
        const appid = "wx09414caa1ad76a62";
        const redirectUri = encodeURIComponent("https://extendfront.wthui.cn");
        const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
        window.location.href = authUrl;
      } else {
        // ponytail: 浏览器模式无真实 openId，用占位值走账号密码登录；
        localStorage.setItem("openId", "browser-dev");
        openid.value = "browser-dev";
      }
    }

    return {
      username,
      password,
      rememberPwd,
      servicePhones,
      onSubmit,
      openid,
      // toResetPwd,
    };
  },
};
</script>

<style scoped>
.remember-pwd-wrapper {
  margin: 12px 18px 0 18px;
  padding: 0 10px;
}

.remember-pwd-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.remember-pwd-checkbox {
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #dcdee0;
  border-radius: 3px;
  margin-right: 6px;
  position: relative;
  background-color: #fff;
  transition: all 0.2s ease;
}

.remember-pwd-checkbox:checked {
  background-color: #52c1b2;
  border-color: #52c1b2;
}

.remember-pwd-checkbox:checked::after {
  content: "";
  position: absolute;
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.remember-pwd-text {
  font-size: 14px;
  color: #323233;
}

/* 账号来源提示：小字灰色居中，无装饰 */
.login-tip {
  margin: -4px 18px 0;
  text-align: center;
  font-size: 12px;
  color: #999999;
  line-height: 18px;
}

/* 服务电话：固定在页面下方，纯展示不可点 */
.service-hotline {
  position: fixed;
  bottom: 24px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 12px;
  color: #bbbbbb;
  line-height: 20px;
}

.hotline-label {
  letter-spacing: 1px;
}

.hotline-nums span {
  margin: 0 7px;
}
</style>
